import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError, map, Observable, of, retry, tap } from 'rxjs';
import { StorageService } from '../storage/storage.service';
import { Apollo, gql } from 'apollo-angular';



@Injectable({
  providedIn: 'root'
})
export class InvoiceScannerService {

  // private readonly httpClient: HttpClient = inject(HttpClient);
  private readonly apollo: Apollo = inject(Apollo);


  constructor() { }


  public generatePIN(medium: string, contact: string, identificationValue: string = '', firstName: string = '', status: string = 'PENDING'): Observable<any> {

    return this.apollo.mutate({
      mutation: gql`
      mutation GeneratePIN( $generatePINInput: GeneratePINInput! ) {
        generatePIN( generatePINInput: $generatePINInput ) {
          success
          message
        }
      }`, variables: { generatePINInput: { medium, contact, identificationValue, firstName, status }}
    }).pipe(
      retry(3),
      map(({ data: { generatePIN: { success, message }}}: any) => success ? 'SENT' : message === 'EXPIRED' ? message : 'ERROR'),
      catchError(() => of('ERROR'))
    );
  }


  public validatePIN(medium: string, contact: string, PIN: string): Observable<any> {
    return this.apollo.mutate({
      mutation: gql`
      mutation ValidatePIN( $validatePINInput: ValidatePINInput! ) {
        validatePIN( validatePINInput: $validatePINInput ) {
          success
          message
        }
      }`,
      variables: { validatePINInput: { medium, contact, PIN } }
    }).pipe(
      retry(3),
      map(({ data: { validatePIN: { success, message }}}: any) => success ? message : 'ERROR'),
      catchError(() => of('ERROR'))
    );
  }


  public getTermsAndConditions(): Observable<any> {
    return this.apollo.query({
      query: gql`
        query GetLegalTerms {
          getLegalTerms {
            code
            message
            success
            payload {
              crmPoints {
                content
                title
                version
              }
              legalTerms {
                content
                title
                version
              }
            }
          }
        }`,
    }).pipe(
      retry(3),
      // tap(({ data: { getLegalTerms: { success, message, payload }}}: any) => console.log({ success, message, payload })),
      map(({ data: { getLegalTerms: { success, payload }}}: any) => success ? payload : 'ERROR'),
      catchError(() => of('ERROR'))
    );
  }


  public sendForm(form: any): Observable<any> {
    return this.apollo.mutate({
      errorPolicy: 'all',
      mutation: gql`
      mutation CreateInvoiceScanner( $createInvoiceScannerInput: CreateInvoiceScannerInput! ) {
        createInvoiceScanner( createInvoiceScannerInput: $createInvoiceScannerInput ) {
          message
          success
          code
        }
      }`,
      variables: {
        createInvoiceScannerInput: form,
      }
    }).pipe(
      retry(3),
      map(({ data, error }) =>
        !!data ? data : { createInvoiceScanner: { success: false, message: error?.message || 'BACK_ERROR' }}
      ),
      map(({ createInvoiceScanner: { success, message }}: any): any => ({ success, message })),
      catchError(() => of({ success: false, message: 'CATCH_ERROR' }))
    );
  }
}
